import React, { useEffect, useState } from 'react';
import Sidebar from '../components/Sidebar';
import "./dashboard.css";
import { Link, useSearchParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { getallmembershiptypes } from '../store/slices/userSlice';
import PaginatedTable from '../services/paginatedtable';
import Swal from "sweetalert2";
import Membershippaymentsmodal from './membershippaymentsmodal';
import { getallmembershippaymentsbydate } from '../store/slices/userSlice';

function Membershippaymentsbydate() {
  const [searchParams] = useSearchParams();
  const [id, setId] = useState(null);
  const [total, setTotal] = useState();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);  // Initialize as empty array, not true
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false); // <-- Added this line

  const [selected, setSelected] = useState(null);

  const [startdate, setStartdate] = useState(null);
  const [enddate, setEnddate] = useState(null);

  const fetchData = async () => {
    setError(null);
    try {

      const response = await getallmembershippaymentsbydate(startdate, enddate);
      setData(Array.isArray(response?.data) ? response.data : []);
    } catch (err) {
      Swal.fire('Error', 'Error getting data.', 'error');
      setError('Error getting data.');
    } finally {
      //setLoading(false);
    }
  };

  useEffect(() => {
    try {
      setLoading(false);
    } catch (error) {
      console.error("Error in useEffect:", error);
    }
  }, []);
  
  const handleEdit = (item) => {
    try {
      setSelected(item);
      setIsModalOpen(true);
    } catch (error) {
      console.error("Error in handleEdit:", error);
    }
  };
  

  return (
    <div>
      <Navbar />
      <Sidebar />
      {loading && (
        <div className="preloader">
          <div className="lds-ripple">
            <div className="lds-pos"></div>
            <div className="lds-pos"></div>
          </div>
        </div>
      )}

      <div id="main-wrapper">
        <div className="page-wrapper d-block">
          <div className="body-wrapper">
            <div className="container-fluid">
              <div className="folio-container"></div>
              <div className="row">
                <div className="col-lg-12 d-flex align-items-stretch">
                  <div className="card w-100">
                    <div className="card-header" style={{ background: "#f06969" }}>
                      <div className="d-sm-flex d-block align-items-center justify-content-between mb-4">
                        <h4 className="card-title fw-semibold">Membership Payments By Date</h4>

                      </div>
                    </div>
                    <div className="card-body">

                      <div className="d-flex flex-wrap align-items-center gap-3 my-3">
                        <div>
                          <label className="form-label mb-1">Start Date</label>
                          <input
                            type="date"
                            className="form-control"
                            value={startdate || ""}
                            onChange={(e) => setStartdate(e.target.value)}
                          />
                        </div>
                        <div>
                          <label className="form-label mb-1">End Date</label>
                          <input
                            type="date"
                            className="form-control"
                            value={enddate || ""}
                            onChange={(e) => setEnddate(e.target.value)}
                          />
                        </div>
                        <div className="align-self-end">
                          <button className="btn btn-primary" onClick={fetchData}>
                            Get Report
                          </button>
                        </div>
                      </div>

                      <div className="col-lg-12">
                        {loading ? (
                          <p>Loading...</p>
                        ) : error ? (
                          <p className="text-danger">Error: {error}</p>
                        ) : data.length > 0 ? (
                          <div className="table-responsive">
                            <PaginatedTable
                              columns={[
                                "date",
                                "member_name",
                                "membership_type",
                                "amount",
                                "paymentmode",
                                "transactionid",
                                "chequenumber",
                                "bank",
                                "chequedate",
                                "status",
                              ]}
                              data={data}
                              onEdit={handleEdit}

                            />
                          </div>
                        ) : (
                          <p>No data available</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <Membershippaymentsmodal
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    reloadData={fetchData}
                    selected={selected}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Membershippaymentsbydate;
